import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import thunk from "redux-thunk";
import { connectRouter, routerMiddleware } from "connected-react-router";

import * as Configuration from "../components/digitalactivation/configuration/reducer";
import * as Firmware from "../components/digitalactivation/firmware/reducer";
import * as UserManagement from "../components/digitalactivation/user-management/reducer";
import * as ProductLicense from "../components/digitalactivation/feature-keys/reducer";
import * as Entitlement from "../components/digitalactivation/licenses/reducer";
import * as Voucher from "../components/digitalactivation/vouchers/reducer";
import * as voucherOverview from "../components/digitalactivation/voucher-overview/reducer";
import * as account from "../container/reducer";

export default function configureStore(history, initialState) {
  const reducers = {
    configuration: Configuration.reducer,
    firmware: Firmware.reducer,
    user: UserManagement.reducer,
    productLicense: ProductLicense.reducer,
    entitlement: Entitlement.reducer,
    voucher: Voucher.reducer,
    voucherOverview: voucherOverview.reducer,
    account: account.reducer,
  };

  const middleware = [thunk, routerMiddleware(history)];

  // In development, use the browser's Redux dev tools extension if installed
  const enhancers = [];
  const isDevelopment = process.env.NODE_ENV === "development";
  if (
    isDevelopment &&
    typeof window !== "undefined" &&
    window.devToolsExtension
  ) {
    enhancers.push(window.devToolsExtension());
  }

  const rootReducer = combineReducers({
    ...reducers,
    router: connectRouter(history),
  });

  // const persistConfig = {
  //     key: 'root',
  //     storage,
  // }

  // const persistedReducer = persistReducer(persistConfig, rootReducer)

  // let store = createStore(
  //     persistedReducer,
  //     initialState,
  //     compose(applyMiddleware(...middleware), ...enhancers)
  // );

  // let persistor = persistStore(store)

  return createStore(
    rootReducer,
    initialState,
    compose(applyMiddleware(...middleware), ...enhancers)
  );
}
